import React, { FC } from 'react';
import Slider from 'react-slick';
import { TCarouselForEE } from '../../types/herobanner.types';
import HeroCarouselSlide from '../heroCarouselSlide';

const CarouselForEE: FC<TCarouselForEE> = ({ items }) => {
  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <Slider {...settings}>
      {items.map((itemFields) => (
        <div className="slide" key={itemFields.id}>
          <HeroCarouselSlide fields={itemFields} />
        </div>
      ))}
    </Slider>
  );
};

export default CarouselForEE;
